module.exports = __webpack_public_path__ + "img/tank_diagram.d2f681d0.png";